export default {
  nav: {
    home: 'Shtëpia',
    products: 'Të gjitha produktet',
    categories: 'Kategoritë',
    about: 'Rreth nesh',
    contact: 'Kontakt',
    trackService: 'Gjurmo Servisin',
    trackOrder: 'Gjurmo Porosinë',
    login: 'Identifikohu',
  },
  titles: {
    home: 'Kreu',
    products: 'Të gjitha produktet',
    productDetail: 'Detajet e produktit',
    category: 'Kategoria',
    cart: 'Shporta',
    checkout: 'Pagesa',
    search: 'Kërkimi',
    wishlist: 'Lista e dëshirave',
    about: 'Rreth nesh',
    contact: 'Kontakt',
    login: 'Kyçu',
    register: 'Regjistrohu',
    privacy: 'Politika e Privatësisë',
    terms: 'Kushtet e Përdorimit',
    returns: 'Politika e Kthimit',
    delivery: 'Informacion për Dërgesën',
    account: 'Llogaria ime',
    orderSuccess: 'Porosia u konfirmua',
    trackService: 'Gjurmo Servisin',
    bookService: 'Rezervo Servis',
    forgotPassword: 'Rivendos fjalëkalimin',
    signingIn: 'Duke u identifikuar...',
  },
  header: {
    searchPlaceholder: 'Kërko produkte...',
    searchPlaceholderMobile: 'Kërko...',
    profile: 'Profili',
    login: 'Identifikohu',
    account: 'Llogaria',
    register: 'Regjistrohu',
    wishlist: 'Lista e dëshirave',
    cart: 'Shporta',
    freeShipping: '🚚 Dërgesë falas mbi {threshold} {currency}',
  },
  footer: {
    description: 'Destinacioni juaj për elektronikë, pjesë dhe shërbim profesional. Produkte cilësore me çmime të arsyeshme.',
    quickLinks: 'Lidhje të shpejta',
    allProducts: 'Të gjitha produktet',
    help: 'Ndihmë',
    delivery: 'Dërgesa',
    returns: 'Kthimi i produkteve',
    terms: 'Kushtet e përdorimit',
    privacy: 'Politika e privatësisë',
    contact: 'Kontakt',
    contactInfo: 'Kontakt',
    workingHours: 'E Hënë-E Shtunë: 09:00 - 20:00',
    paymentMethods: 'Metodat e pagesës:',
    securePayment: '🔒 Pagesë e sigurt',
    fastDelivery: '🚚 Dërgesë e shpejtë',
    returnPolicy: '↩️ 14 ditë kthim',
    allRightsReserved: 'Të gjitha të drejtat e rezervuara.',
    termsShort: 'Kushtet',
    privacyShort: 'Privatësia',
    returnsShort: 'Kthimi',
    deliveryShort: 'Dërgesa',
  },
  home: {
    heroTitle: 'Elektronika më e mirë në një vend',
    heroSubtitle: 'Produkte cilësore, pjesë riparimi dhe shërbim profesional. Dërgesë në të gjithë Maqedoninë.',
    shopNow: 'Bli tani',
    featuredProducts: 'Produkte të rekomanduara',
    categories: 'Kategoritë',
    whyChooseUs: 'Pse të na zgjidhni?',
    quality: 'Cilësia',
    qualityDesc: 'Vetëm produkte të verifikuara nga furnitorë të besueshëm',
    fastDelivery: 'Dërgesë e shpejtë',
    fastDeliveryDesc: 'Dërgesë në të gjithë Maqedoninë për 24-48 orë',
    support: 'Mbështetje',
    supportDesc: 'Ekip profesional në dispozicion 24/7',
    warranty: 'Garancion',
    warrantyDesc: 'Garancion për të gjitha produktet dhe shërbimet',
    freeShipping: 'Transport Falas',
    freeShippingOver: 'mbi {threshold} {currency}',
    securePayment: 'Pagesë e Sigurt',
    sslProtection: 'Mbrojtje SSL',
    returnPolicy: '14 Ditë Kthim',
    noQuestions: 'pa pyetje',
    support247: 'Mbështetje 24/7',
    hereForYou: 'jemi këtu për ju',
    products: 'produkte',
    needService: 'Keni nevojë për shërbim?',
    serviceDescription: 'Sillni pajisjen tuaj për diagnozë falas. Riparim profesional me garanci.',
    bookService: 'Rezervo Shërbim',
  },
  service: {
    title: 'Rezervo Shërbim',
    subtitle: 'Zgjidhni shërbimin që ju nevojitet dhe ne do t\'ju kontaktojmë sa më shpejt të jetë e mundur.',
    selectService: 'Zgjidh Shërbimin',
    repair: 'Shërbim Riparimi',
    review: 'Recension i Produktit',
    sell: 'Shisni Produktin Tuaj',
    showcase: 'Prezantim i Produktit',
    fullName: 'Emri i Plotë',
    phoneNumber: 'Numri i Telefonit',
    emailAddress: 'Adresa e Email-it',
    description: 'Përshkrimi / Detajet',
    descriptionPlaceholder: 'Përshkruani problemin me pajisjen tuaj...',
    tellUsMore: 'Na tregoni më shumë...',
    submitRequest: 'Dërgo Kërkesën',
    sendingRequest: 'Duke u dërguar...',
  },
  category: {
    notFound: 'Kategoria nuk u gjet',
    productsCount: 'produkte',
    empty: 'Nuk ka produkte në këtë kategori',
  },
  products: {
    title: 'Të gjitha produktet',
    items: 'produkte',
    noProducts: 'Nuk ka produkte në dispozicion',
    noProductsFound: 'Nuk u gjetën produkte',
    loading: 'Duke u ngarkuar...',
    addToCart: 'Shto në shportë',
    inStock: 'Në stok',
    outOfStock: 'Nuk ka në stok',
    price: 'Çmimi',
    minPrice: 'Min',
    maxPrice: 'Max',
    viewDetails: 'Shiko detajet',
    viewAll: 'Shiko të gjitha',
    search: 'Kërko',
    searchPlaceholder: 'Kërko produkte...',
    categories: 'Kategoritë',
    allCategories: 'Të gjitha kategoritë',
    sortBy: 'Rendit sipas',
    sortByName: 'Sipas emrit',
    sortByPrice: 'Sipas çmimit',
    sortByDate: 'Sipas datës',
    sortAscending: 'Në rritje',
    sortDescending: 'Në zbritje',
    previous: 'Paraardhës',
    next: 'Tjetër',
    page: 'Faqja {current} nga {total}',
  },
  product: {
    addToCart: 'Shto në shportë',
    added: 'Shtuar',
    reviews: 'Vlerësimet',
    reviewsComingSoon: 'Vlerësimet së shpejti',
    reviewsDesc: 'Funksioni i vlerësimeve të klientëve do të jetë i disponueshëm së shpejti në dyqanin tonë.',
    inStock: 'Në stok',
    outOfStock: 'Nuk ka në stok',
    quantity: 'Sasia',
    description: 'Përshkrimi',
    specifications: 'Specifikimet',
    relatedProducts: 'Produkte të ngjashme',
    stock: 'Stoku',
    showStock: 'Shfaq stokun',
    hideStock: 'Fshih stokun',
    sku: 'SKU',
    barcode: 'Barkod',
    includesTax: 'përfshin TVSH',
    priceWithoutTax: 'Çmimi pa TVSH',
    pieces: 'copë',
    fastDelivery: 'Dërgesë e shpejtë',
    deliveryDays: '1-3 ditë',
    warranty: 'Garancion',
    warrantyMonths: '12 muaj',
    returns: 'Kthimi',
    returnDays: '14 ditë',
    freeShipping: 'Dërgesë falas!',
    shipping: 'Dërgesa',
    qualifiesForFreeShipping: 'Porosia juaj kualifikohet për dërgesë falas',
    addMoreForFreeShipping: 'Shtoni {amount} më shumë për dërgesë falas',
    total: 'Totali',
    acceptedPaymentMethods: 'Metodat e pranuara të pagesës',
    cash: 'Para',
    card: 'Kartë',
    bankTransfer: 'Transfer bankar',
    mobilePayment: 'Pagesë mobile',
    noDescription: 'Nuk ka përshkrim për këtë produkt.',
    unit: 'Njësia',
    piece: 'Copë',
    category: 'Kategoria',
    locations: 'Vendndodhjet',
    addedToCart: 'Produkti u shtua në shportë!',
    vat: 'TVSH',
  },
  cart: {
    title: 'Shporta',
    empty: 'Shporta juaj është e zbrazët',
    continueShopping: 'Vazhdo me blerjen',
    subtotal: 'Nëntotali',
    tax: 'Taksa',
    total: 'Totali',
    checkout: 'Paguaj',
    remove: 'Hiq',
    emptyCart: 'Bosh shportën',
    shipping: 'Transporti',
    free: 'Falas',
    freeShippingMessage: 'Shto edhe {amount} për transport falas',
    proceedToCheckout: 'Vazhdo te pagesa',
    summary: 'Përmbledhja e porosisë',
  },
  checkout: {
    title: 'Paguaj',
    shippingInfo: 'Informacion për dërgesën',
    paymentMethod: 'Metoda e pagesës',
    orderSummary: 'Përmbledhje e porosisë',
    placeOrder: 'Konfirmo porosinë',
    name: 'Emri dhe mbiemri',
    email: 'Email',
    phone: 'Telefoni',
    address: 'Adresa',
    city: 'Qyteti',
    postalCode: 'Kodi postar',
    notes: 'Shënime (opsionale)',
    cash: 'Para',
    card: 'Kartë',
    bankTransfer: 'Transfer bankar',
    mobilePayment: 'Pagesë mobile',
    thankYou: 'Faleminderit për porosinë tuaj!',
    orderConfirmed: 'Porosia juaj #{orderNumber} u konfirmua.',
    confirmationEmail: 'Ne ju kemi dërguar një email konfirmimi me të gjitha detajet.',
    guestCheckout: 'Porosi si mysafir',
    guestCheckoutDesc: 'Mund të porosisni pa krijuar llogari. Do t\'ju dërgojmë konfirmimin në email.',
  },
  about: {
    title: 'Rreth nesh',
    defaultDescription: 'Mirë se vini në {storeName}!',
    defaultContent: 'Ne jemi të përkushtuar për të ofruar produktet dhe shërbimet më të mira për klientët tanë.',
    contactInfo: 'Informacion kontakti',
    name: 'Emri',
    email: 'Email',
    phone: 'Telefoni',
    address: 'Adresa',
    followUs: 'Na ndiqni',
    subtitle: 'Partneri juaj i besuar për zgjidhje elektronike dhe teknologjike.',
    socialDescription: 'Qëndroni të informuar me ofertat dhe lajmet tona më të fundit duke na ndjekur në rrjetet sociale.',
    qualityTitle: 'Cilësi e Garantuar',
    qualityDesc: 'Ne garantojmë 100% produkte autentike direkt nga prodhuesit e certifikuar.',
    deliveryTitle: 'Dërgesa të Shpejta',
    deliveryDesc: 'Partnerë të besueshëm transporti që sigurojnë që porositë tuaja të arrijnë në kohë.',
    secureTitle: 'Pagesë e Sigurt',
    secureDesc: 'Transaksionet tuaja mbrohen me standardet më të larta të sigurisë industriale.',
  },
  contact: {
    title: 'Kontakt',
    getInTouch: 'Lidhuni me ne',
    sendMessage: 'Dërgo mesazh',
    name: 'Emri',
    email: 'Email',
    subject: 'Tema',
    message: 'Mesazhi',
    send: 'Dërgo mesazh',
    phone: 'Telefoni',
    address: 'Adresa',
    subtitle: 'Ne jemi këtu për të ndihmuar dhe për t\'iu përgjigjur çdo pyetjeje që mund të keni.',
    success: 'Mesazhi juaj u dërgua me sukses! Do t\'ju kontaktojmë së shpejti.',
    sending: 'Duke dërguar...',
  },
  search: {
    title: 'Rezultatet e kërkimit',
    query: 'Duke kërkuar për: "{query}"',
    noResults: 'Nuk u gjetën rezultate për "{query}"',
    tryAgain: 'Provoni fjalë kyçe të tjera',
    enterTerm: 'Ju lutem shkruani një term kërkimi',
  },
  register: {
    title: 'Regjistrohu',
    firstName: 'Emri',
    lastName: 'Mbiemri',
    email: 'Email',
    phone: 'Telefoni',
    phonePlaceholder: '+389 7X XXX XXX',
    password: 'Fjalëkalimi',
    confirmPassword: 'Konfirmo fjalëkalimin',
    passwordsDoNotMatch: 'Fjalëkalimet nuk përputhen',
    marketingConsent: 'Dëshiroj të marr mesazhe marketingu',
    submit: 'Regjistrohu',
    registering: 'Duke u regjistruar...',
    success: 'Regjistrimi u krye me sukses!',
    error: 'Gabim në regjistrim',
    alreadyHaveAccount: 'Keni tashmë një llogari?',
    backToHome: 'Kthehu në shtëpi',
  },
  login: {
    title: 'Identifikohu',
    email: 'Email',
    password: 'Fjalëkalimi',
    submit: 'Identifikohu',
    loggingIn: 'Duke u identifikuar...',
    error: 'Gabim në identifikim',
    noAccount: 'Nuk keni llogari?',
    registerHere: 'Regjistrohuni këtu',
    successMessage: 'Jeni identifikuar me sukses.',
    rememberMe: 'Më mbaj mend',
    forgotPassword: 'Keni harruar fjalëkalimin?',
    orContinueWith: 'Ose vazhdo me',
    signInWithGoogle: 'Identifikohu me Google',
    signInWithFacebook: 'Identifikohu me Facebook',
  },
  account: {
    title: 'Llogaria Ime',
    welcome: 'Mirësevini, {name}',
    completeProfileMessage: 'Ju lutemi shtoni numrin tuaj të telefonit për të kompletuar profilin.',
    details: 'Detajet e llogarisë',
    logout: 'Dil',
    orders: 'Historiku i porosive',
    noOrders: 'Nuk keni porosi akoma.',
    orderNumber: 'Numri i porosisë',
    date: 'Data',
    total: 'Totali',
    cancelOrder: 'Anulo porosinë',
    confirmCancel: 'A jeni i sigurt se doni të anuloni këtë porosi?',
    orderCancelled: 'Porosia u anulua me sukses',
    profile: 'Profili',
    addresses: 'Adresat',
    security: 'Siguria',

    // Address form
    addressName: 'Emri i adresës (sh.sh. Shtëpi)',
    streetAddress: 'Rruga',
    city: 'Qyteti',
    postalCode: 'Kodi Postar',
    country: 'Shteti',
    defaultShippingAddress: 'Adresa parazgjedhur e dërgesës',
    setAsDefault: 'Vendos si adresë kryesore të dërgesës',
    editAddress: 'Ndrysho adresën',
    newAddress: 'Adresë e re',
    addAddress: 'Shto të re',
    addressUpdated: 'Adresa u përditësua',
    addressCreated: 'Adresa u krijua',
    addressDeleted: 'Adresa u fshi',
    deleteAddressConfirm: 'A jeni i sigurt që doni të fshini këtë adresë?',
    saveChanges: 'Ruaj ndryshimet',
    notificationPreferences: 'Preferencat e njoftimeve',
    emailNotifications: 'Njoftime me Email',
    smsNotifications: 'Njoftime me SMS',
    whatsappNotifications: 'Njoftime me WhatsApp',
    profileUpdated: 'Profili u përditësua me sukses',
    passwordChanged: 'Fjalëkalimi u ndryshua me sukses',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalimi i ri',
    changePassword: 'Ndrysho fjalëkalimin',
  },
  forgotPassword: {
    title: 'Rivendos fjalëkalimin',
    subtitle: "Shkruani adresën tuaj të emailit dhe ne do t'ju dërgojmë një lidhje për të rivendosur fjalëkalimin tuaj.",
    email: 'Adresa e emailit',
    submit: 'Dërgo lidhjen',
    sending: 'Duke u dërguar...',
    backToLogin: 'Kthehu te hyrja',
    success: 'Lidhja u dërgua! Ju lutemi kontrolloni emailin tuaj.',
    error: 'Dërgimi dështoi. Ju lutemi provoni përsëri.',
  },
  common: {
    loading: 'Duke u ngarkuar...',
    error: 'Gabim',
    tryAgain: 'Provo përsëri',
    back: 'Mbrapa',
    close: 'Mbyll',
    save: 'Ruaj',
    cancel: 'Anulo',
    delete: 'Fshi',
    edit: 'Redakto',
    view: 'Shiko',
    yes: 'Po',
    no: 'Jo',
    currency: 'MKD',
    language: 'Gjuha',
    continueShopping: 'Vazhdo blerjen',
    track: 'Gjurmo',
    select: 'Zgjidh',
    previous: 'Përparshme',
    next: 'Tjetra',
    fillRequiredFields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara',
    required: 'E detyrueshme',
    invalidEmail: 'Email i pavlefshëm',
    invalidPhone: 'Numër telefoni i pavlefshëm',
    pageOf: 'Faqja {current} nga {total}',
    processing: 'Duke përpunuar...',
    noData: 'Nuk ka të dhëna të disponueshme',
  },
  track: {
    title: 'Gjurmo Servisin Tuaj',
    subtitle: 'Shkruani ID e shërbimit ose numrin e gjurmimit për të parë statusin.',
    placeholder: 'p.sh. SRV-12345',
    notFound: 'Urdhri i shërbimit nuk u gjet',
    details: 'Detajet e shërbimit',
    date: 'Data',
    estimatedCompletion: 'Përfundimi i parashikuar',
  },
  wishlist: {
    title: 'Lista ime e dëshirave',
    empty: 'Lista juaj e dëshirave është bosh',
    emptyMessage: 'Ruani artikujt që ju pëlqejnë për t\'i rishikoni më vonë.',
    addToWishlist: 'Shto në listën e dëshirave',
    removeFromWishlist: 'Hiq nga lista e dëshirave',
    removed: 'U hoq nga lista e dëshirave',
    added: 'U shtua në listën e dëshirave',
  },
  serviceStatus: {
    received: 'Pranuar',
    diagnosing: 'Duke diagnostikuar',
    waiting_approval: 'Në pritje të miratimit',
    approved: 'Miratuar',
    in_progress: 'Në progres',
    waiting_parts: 'Në pritje të pjesëve',
    ready: 'Gati',
    delivered: 'Tërhequr',
    cancelled: 'Anuluar',
  },
  policies: {
    common: {
      lastUpdated: 'Përditësimi i fundit: {date}',
      contact: {
        title: 'Kontakt',
        text: 'Për pyetje, ju lutemi na kontaktoni:',
        hours: 'Orari i punës: E hënë - E premte: 09:00 - 18:00, E shtunë: 09:00 - 14:00'
      }
    },
    delivery: {
      title: 'Politika e Dërgesës',
      intro: 'Ne dërgojmë porosi në të gjithë territorin e Republikës së Maqedonisë së Veriut. Ne punojmë me kompani korrierësh të besueshëm për të siguruar dërgesë të sigurt dhe në kohë.',
      areas: {
        title: '1. Zonat e Dërgesës',
        skopje: { title: 'Shkup dhe rrethina', text: 'Dërgesa standarde: 1-2 ditë pune' },
        other: { title: 'Qytetet e tjera', text: 'Dërgesa standarde: 2-4 ditë pune' },
        remote: { title: 'Zonat e thella', text: 'Dërgesa standarde: 3-5 ditë pune' },
        express: { title: 'Dërgesa Express', text: 'E disponueshme për zona të zgjedhura: 24 orë' }
      },
      time: {
        title: '2. Koha e Përpunimit dhe Dërgesës',
        processingTitle: 'Përpunimi i Porosisë',
        processingList: [
          'Porositë përpunohen brenda 1-2 ditëve të punës',
          'Porositë e marra para orës 14:00 përpunohen të njëjtën ditë',
          'Porositë e marra pas orës 14:00 përpunohen ditën tjetër të punës',
          'Gjatë pushimeve dhe fundjavave, përpunimi mund të vonohet'
        ],
        deliveryTitle: 'Koha e Dërgesës',
        deliveryList: [
          'Koha e dërgesës llogaritet nga momenti i nisjes',
          'Ditët e punës janë nga e hëna në të premte (përveç festave zyrtare)',
          'Ju do të merrni një SMS ose email me informacionet e dërgesës',
          'Ju mund të gjurmoni dërgesën tuaj me numrin e gjurmimit'
        ]
      },
      costs: {
        title: '3. Kostot e Dërgesës',
        freeTitle: 'Dërgesë Falas',
        freeText: 'Dërgesë falas është e disponueshme për porosi mbi {amount} denarë.',
        standardTitle: 'Dërgesa Standarde',
        standardList: [
          'Shkup dhe rrethina: 150 - 250 denarë',
          'Qytetet e tjera: 200 - 350 denarë',
          'Zonat e thella: 300 - 500 denarë',
          'Kostot e sakta shfaqen gjatë porositjes'
        ],
        expressTitle: 'Dërgesa Express',
        expressText: 'Dërgesa Express (24 orë) është e disponueshme për zona të zgjedhura. Kostot shfaqen gjatë porositjes.'
      },
      methods: {
        title: '4. Mënyrat e Dërgesës',
        home: { title: 'Dërgesë në Adresë', text: 'Korrieri do të sjellë produktin në adresën tuaj. Ju lutemi sigurohuni për saktësinë e adresës dhe praninë gjatë dërgesës.' },
        box: { title: 'Dërgesë në Kuti Postare', text: 'Ju mund të zgjidhni dërgesë në një kuti postare në një lokacion të zgjedhur. Do të njoftoheni kur dërgesa të jetë gati.' },
        store: { title: 'Marrja nga Dyqani', text: 'Mund të merrni produktin nga dyqani ynë. Ne do t\'ju njoftojmë kur porosia të jetë gati.' },
        work: { title: 'Dërgesë në Vendin e Punës', text: 'Mund të porosisni dërgesë në vendin tuaj të punës. Ju lutemi jepni adresë të saktë dhe informacione kontakti.' }
      },
      delays: {
        title: '7. Vonesat dhe Problemet',
        text1: 'Ndërsa përpiqemi të respektojmë afatet e deklaruara, mund të ketë vonesa për shkak të rrethanave të paparashikuara (mot i keq, probleme trafiku, etj.).',
        text2: 'Nëse dërgesa juaj vonohet më shumë se 2 ditë pune nga afati i deklaruar, ju lutemi na kontaktoni për të kontrolluar statusin.'
      }
    },
    return: {
      title: 'Politika e Kthimit',
      intro: 'Në përputhje me Ligjin për Mbrojtjen e Konsumatorit të Republikës së Maqedonisë së Veriut, ju keni të drejtë të anuloni produktin e porositur brenda 14 ditëve kalendarike nga data e marrjes, pa dhënë ndonjë arsye.',
      introTitle: 'E Drejta Juaj për Kthim',
      deadline: {
        title: '1. Afati i Kthimit',
        text1: 'Afati prej 14 ditësh fillon nga dita kur ju ose një palë e tretë (përveç transportuesit) e caktuar nga ju merr produktin.',
        text2: 'Për të ushtruar të drejtën e kthimit, duhet të na njoftoni për vendimin tuaj përmes një deklarate të qartë (p.sh., letër me postë, faks ose email) para skadimit të afatit 14-ditor.'
      },
      conditions: {
        title: '2. Kushtet e Kthimit',
        mustBeTitle: 'Produkti duhet të jetë:',
        mustBeList: [
          'Në gjendje origjinale, i papërdorur',
          'Me paketim origjinal dhe etiketa',
          'Me të gjitha shtojcat dhe dokumentet (nëse ka)',
          'Pa dëmtime ose gjurmë përdorimi'
        ],
        cannotBeTitle: 'Produkte që nuk mund të kthehen:',
        cannotBeList: [
          'Produkte të personalizuara të bëra sipas specifikimeve tuaja',
          'Produkte që prishen shpejt ose kanë afat të shkurtër skadence',
          'Produkte të vulosura të hapura pas dërgesës (CD, DVD, softuer)',
          'Produkte që nuk janë të përshtatshme për kthim për arsye shëndetësore ose higjienike'
        ]
      },
      process: {
        title: '3. Procesi i Kthimit',
        step1: { title: 'Hapi 1', subtitle: 'Na Kontaktoni' },
        step2: { title: 'Hapi 2', subtitle: 'Përgatitni Produktin', text: 'Vendosni produktin në paketimin origjinal me të gjitha shtojcat dhe dokumentet.' },
        step3: { title: 'Hapi 3', subtitle: 'Dërgoni Produktin', text: 'Dërgojeni në adresën tonë.' }
      },
      costs: {
        title: '4. Kostot e Kthimit',
        text1: 'Nëse produkti është me defekt ose nuk përputhet me përshkrimin: Ne mbulojmë të gjitha kostot e kthimit.',
        text2: 'Nëse e ktheni produktin pa arsye (brenda të drejtës ligjore): Kostot e kthimit janë në shpenzimin tuaj.'
      },
      refund: {
        title: '5. Rimbursimi',
        text1: 'Ne do të rimbursojmë shumën që keni paguar për produktin (përfshirë kostot standarde të dërgesës) brenda 14 ditëve kalendarike nga marrja e produktit të kthyer.',
        text2: 'Rimbursimi do të bëhet duke përdorur të njëjtën metodë pagese që keni përdorur për transaksionin fillestar.',
        note: 'Shënim: Ne mund të zbresim një shumë për uljen e vlerës së produktit nëse ai është dëmtuar për fajin tuaj.'
      },
      exchange: {
        title: '6. Ndërrimi i Produktit',
        text: 'Nëse dëshironi të ndërroni produktin me një tjetër, ju lutemi na kontaktoni. Ne do të përpiqemi të plotësojmë kërkesën tuaj, me kusht që produkti të jetë i disponueshëm.'
      },
      warranty: {
        title: '7. Garancia',
        text: 'Kjo politikë kthimi nuk ndikon në të drejtat tuaja ligjore të garancisë. Nëse produkti ka një defekt prodhimi, ju keni të drejtë për riparim, zëvendësim ose rimbursim në përputhje me garancinë e prodhuesit.'
      }
    },
    privacy: {
      title: 'Politika e Privatësisë',
      intro: '{storeName} është e përkushtuar në mbrojtjen e privatësisë suaj. Kjo politikë shpjegon se si ne mbledhim, përdorim, ruajmë dhe mbrojmë të dhënat tuaja personale kur përdorni faqen tonë të internetit dhe shërbimet tona.',
      introTitle: '1. Hyrje',
      collection: {
        title: '2. Të Dhënat që Mbledhim',
        givenTitle: '2.1. Të dhënat që na jepni',
        givenList: ['Emri dhe Mbiemri', 'Adresa e Email-it', 'Numri i Telefonit', 'Adresa e Dërgesës', 'Informacionet e Pagesës'],
        autoTitle: '2.2. Të dhënat e mbledhura automatikisht',
        autoList: ['Adresa IP', 'Lloji dhe versioni i shfletuesit', 'Koha e vizitës dhe faqet e shikuara', 'Cookies dhe teknologji të ngjashme']
      },
      usage: {
        title: '3. Si i Përdorim Të Dhënat Tuaja',
        list: [
          'Për të përpunuar dhe dërguar porositë tuaja',
          'Për të komunikuar me ju lidhur me porositë dhe pyetjet tuaja',
          'Për të përmirësuar faqen dhe shërbimet tona',
          'Për të dërguar mesazhe marketingu (vetëm me pëlqimin tuaj)',
          'Për të respektuar detyrimet ligjore'
        ]
      },
      protection: {
        title: '4. Mbrojtja e Të Dhënave',
        text: 'Ne përdorim masa sigurie standarde të industrisë për të mbrojtur të dhënat tuaja personale, përfshirë enkriptimin, serverët e sigurt dhe qasjen e kufizuar në të dhëna vetëm për personelin e autorizuar.'
      },
      sharing: {
        title: '5. Ndarja e Të Dhënave',
        text: 'Ne nuk i shesim të dhënat tuaja personale palëve të treta. Ne mund t\'i ndajmë të dhënat tuaja vetëm me ofruesit e shërbimeve (kompani korrierësh, procesorë pagesash) për përmbushjen e porosive, ose kur kërkohet me ligj.'
      },
      rights: {
        title: '6. Të Drejtat Tuaja',
        text: 'Ju keni të drejtë për:',
        list: ['Qasje në të dhënat tuaja personale', 'Korrigjim të të dhënave të pasakta', 'Fshirje të të dhënave tuaja', 'Kufizim të përpunimit', 'Bartshmëri të të dhënave', 'Kundërshtim ndaj përpunimit']
      },
      cookies: {
        title: '7. Cookies',
        text: 'Ne përdorim cookies për të përmirësuar përvojën tuaj në faqen tonë të internetit. Ju mund të kontrolloni cookies përmes cilësimeve të shfletuesit tuaj.'
      },
      changes: {
        title: '8. Ndryshimet e Politikës',
        text: 'Ne mund ta përditësojmë këtë politikë privatësie herë pas here. Ne do t\'ju njoftojmë për çdo ndryshim të rëndësishëm përmes faqes sonë të internetit ose email-it.'
      }
    },
    terms: {
      title: 'Kushtet e Përdorimit',
      lastUpdated: 'Përditësimi i fundit: {date}',
      section1: {
        title: '1. Pranim i Kushteve',
        text: 'Duke hyrë dhe përdorur faqen e internetit të {storeName}, ju pajtoheni të respektoni këto kushte përdorimi. Nëse nuk pajtoheni me këto kushte, ju lutemi mos e përdorni faqen tonë.'
      },
      section2: {
        title: '2. Porositë dhe Pagesat',
        subsection1: {
          title: '2.1. Procesi i Porosisë',
          list: [
            'Të gjitha porositë i nënshtrohen disponueshmërisë së produktit',
            'Porosia konsiderohet e pranuar kur merrni një konfirmim me email',
            'Ne rezervojmë të drejtën të refuzojmë ose anulojmë një porosi për çdo arsye',
            'Çmimet janë të sakta në momentin e porositjes por mund të ndryshojnë pa njoftim paraprak'
          ]
        },
        subsection2: {
          title: '2.2. Pagesa',
          list: [
            'Ne pranojmë metoda të ndryshme pagese (para në dërgesë, kartë, transfer bankar)',
            'Pagesa duhet të kryhet para ose gjatë dërgesës',
            'Të gjitha çmimet janë në MKD dhe përfshijnë TVSH',
            'Ne rezervojmë të drejtën të kërkojmë verifikim shtesë për siguri'
          ]
        }
      },
      section3: {
        title: '3. Çmimet dhe Disponueshmëria',
        list: [
          'Të gjitha çmimet janë të sakta në momentin e publikimit, por mund të ndryshojnë',
          'Nëse produkti nuk është i disponueshëm pas pranimit të porosisë, ne do t\'ju kontaktojmë',
          'Ne rezervojmë të drejtën të ndryshojmë çmimet pa njoftim paraprak',
          'Çmimet promocionale vlejnë vetëm për një periudhë të caktuar ose derisa të mbarojë stoku'
        ]
      },
      section4: {
        title: '4. Dërgesa',
        text: 'Detajet e dërgesës janë të disponueshme në faqen e dërgesës. Ju lutemi siguroni adresë të saktë dërgese. Ne nuk jemi përgjegjës për vonesa të shkaktuara nga palë të treta (kompani korriere).',
        list: [
          'Koha e dërgesës është e përafërt dhe mund të ndryshojë',
          'Kostot e dërgesës shfaqen gjatë porositjes',
          'Dërgesa falas është e disponueshme për porosi mbi një shumë të caktuar'
        ]
      },
      section5: {
        title: '5. Anulimet dhe Kthimet',
        text: 'Në përputhje me të drejtat e konsumatorit, ju keni të drejtë të anuloni produktin e porositur brenda 14 ditëve nga marrja, pa dhënë arsye.',
        list: [
          'Produkti duhet të jetë në gjendje origjinale, i papërdorur dhe me paketim origjinal',
          'Kostot e kthimit janë në shpenzimin tuaj, përveç nëse produkti është i dëmtuar',
          'Ne do të rimbursojmë shumën brenda 14 ditëve nga marrja e produktit të kthyer',
          'Disa produkte (të personalizuara, produkte të freskëta) nuk mund të kthehen'
        ]
      },
      section6: {
        title: '6. Pronësia Intelektuale',
        text: 'Të gjitha përmbajtjet e faqes në internet, përfshirë tekstet, imazhet, logot dhe dizajnin, mbrohen nga e drejta e autorit dhe janë pronë e {storeName}. Kopjimi ose përdorimi i paautorizuar është i ndaluar.'
      },
      section7: {
        title: '7. Përgjegjësia',
        text: '{storeName} nuk është përgjegjëse për:',
        list: [
          'Dëmet e shkaktuara nga përdorimi ose keqpërdorimi i produkteve tona',
          'Vonesat e dërgesës të shkaktuara nga palë të treta',
          'Probleme teknike ose ndërprerje të faqes në internet',
          'Humbje të të dhënave ose humbje financiare'
        ]
      },
      section8: {
        title: '8. Ndryshimet e Kushteve',
        text: 'Ne rezervojmë të drejtën të ndryshojmë këto kushte në çdo kohë. Ndryshimet do të postohen në këtë faqe interneti dhe hyjnë në fuqi menjëherë pas postimit.'
      },
      section9: {
        title: '9. Ligji i Zbatueshëm',
        text: 'Këto kushte rregullohen nga ligjet e Republikës së Maqedonisë së Veriut. Të gjitha mosmarrëveshjet do të zgjidhen para gjykatave kompetente në Maqedoninë e Veriut.'
      },
      section10: {
        title: '10. Kontakt',
        address: 'Adresa',
        email: 'Email',
        phone: 'Telefoni'
      }
    }
  },
  whatsapp: {
    chatWithUs: 'Bisedoni me ne',
    defaultMessage: 'Përshëndetje! Kam një pyetje për produktet tuaja.'
  }
}
